import type { InjectionToken } from "tsyringe";
import { container } from "tsyringe";

import type { ConstructorMap, DiResolverReturnType } from "./types";

class RewardsDiResolverService {
    resolve<T>(token: InjectionToken<T>): T {
        return container.resolve<T>(token);
    }

    resolveAll<T>(services: ConstructorMap<T>): DiResolverReturnType<T> {
        const result = <DiResolverReturnType<T>>{};

        for (const key in services) {
            const resolved = container.resolve(services[key]);
            result[key] = resolved;
        }

        return result;
    }
}

export default RewardsDiResolverService;
